import { api } from '../../plugins/api'

export default {
    async getCatalogue({ commit }, descid) {
        const response = await api.get(`catalogues/${descid}`)
        commit(`SET_${descid}`, response.data);
        return response.data
    },
    async getCatalogueWithParentContext({ commit }, payload) {
        const response = await api.get(`catalogues/${payload.descid}/${payload.parentdescid}`)
        commit(`SET_PARENT_${payload.parentdescid}`, response.data);
        return response.data
    }
}